module.exports = __webpack_public_path__ + "static/media/7ICJ2.3d251710.jpg";